import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="timer"
export default class extends Controller {
  static values = {
    seconds: Number,
  };

  connect() {
    this.dispatch("started");

    this.timeoutID = setTimeout(() => {
      this.dispatch("finished");
    }, this.secondsValue * 1000);
  }

  disconnect() {
    clearTimeout(this.timeoutID);
  }

  finish() {
    clearTimeout(this.timeoutID);
    this.dispatch("finished");
  }
}
